export default __webpack_public_path__ + "static/media/upushennie_prodaji.8cdaae84.png";